import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

import { PriceType } from '../../api';

@Component({
  selector: 'app-advertisement-price',
  imports: [TranslocoDirective, CurrencyPipe],
  templateUrl: './advertisement-price.component.html',
  styleUrl: './advertisement-price.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvertisementPriceComponent {
  priceType = input.required<PriceType>();
  price = input.required<number>();
  rentPrice = input.required<number | null>();
  PriceType = PriceType;
}
